import(/* webpackChunkName: "gallerySlider" */ '../../Styles/GallerySlider/gallerySlider.scss');
import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');

window.am = window.am || {};

window.am.gallerySlider = new function()
{
    const that = this;

    that.setTextboxHeight = function(slider)
    {
        const slickList = slider.querySelector(".slick-list");
        if (!slickList) {
            return;
        }

        const textboxes = slider.querySelectorAll('figcaption');

        if (!textboxes) {
            return;
        }

        let highestTextBox = 0;

         textboxes.forEach(function(textbox) {
            textbox.style.height = "auto";
        });

        textboxes.forEach(function (textbox) {
            // only items containing text are relevant for height calculation
            if (textbox.innerText.trim() && textbox.offsetHeight > highestTextBox) {
                highestTextBox = textbox.offsetHeight;
            }
        });

        textboxes.forEach(function(textbox) {
            textbox.style.height = highestTextBox + "px";
            if (highestTextBox === 0) {
                textbox.style.padding = 0;
            }
        });

        let elements = slider.querySelectorAll('.gallery-slider-element');
        let highestElement = 0;

        elements.forEach(function (element) {
            var img = element.querySelector('img');

            if (img.classList.contains('lazyloading') || img.classList.contains('lazyloaded')) {
                if (element.offsetHeight > highestElement) {
                    highestElement = element.offsetHeight;
                }
            }
        });

        slickList.style.maxHeight = highestElement + "px";
    }
     
    that.setTabindex = function(slider)
    {
        const prev = slider.querySelector('.prev');
        const next = slider.querySelector('.next');

        if (prev && next) {
            prev.setAttribute('tabindex', '0');
            next.setAttribute('tabindex', '0');
        }
    }

    that.init = function()
    {
        const sliders = document.querySelectorAll(".gallery-slider");
        
        sliders.forEach(function(slider)
        {
            that.setTabindex(slider);
            that.setTextboxHeight(slider);

            $(slider).find('img.lazyload').on('load', function() {
                that.setTextboxHeight(slider);
            });

            window.addEventListener('resize', function()
            {
                that.setTextboxHeight(slider);
            });

            window.addEventListener('orientationchange', function()
            {
                that.setTextboxHeight(slider);
            });
        });
    }
};

window.am.gallerySlider.init();